import { getIcon } from '@/utils/scrapbookUtils';
import { ScrapbookFile } from '@/api';
import { ResponsiveImage } from '@/components';
import { TechLaunchDatabaseModel } from '@/types';

interface TechLaunchDatabaseFileItemProps {
  file: ScrapbookFile;
  selected: boolean;
  onSelect: () => void;
  viewMode?: 'grid' | 'list';
}

const TechLaunchDatabaseFileItem: React.FC<TechLaunchDatabaseFileItemProps> = ({
  file,
  selected,
  onSelect,
  viewMode = 'grid',
}) => {
  const IconComponent = getIcon(file.contentType || '');

  const content = file.content as TechLaunchDatabaseModel;

  if (viewMode === 'list') {
    return (
      <>
        <div className="flex h-[160px] cursor-pointer items-center gap-4 border border-gray-200 bg-white">
          <div className="h-full w-[315px] border-r border-gray-300 bg-gray-50 px-[34px] py-0">
            {content.innovationImages?.imageUrl ? (
              <ResponsiveImage
                image={content.innovationImages}
                widths={{ md: 300, lg: 400 }}
                imgProps={{ className: 'bottom-0 left-0 h-full !object-contain p-0' }}
              />
            ) : (
              <div className="flex h-full items-center justify-center">
                <IconComponent className="h-24 w-24" />
              </div>
            )}
          </div>

          <div className="relative bottom-10 flex-1">
            <h4 className="mb-1 font-bold">Tech Launches Database</h4>
            <h4 className="line-clamp-3 font-medium text-gray-900">{content?.title}</h4>
          </div>
        </div>
      </>
    );
  }

  return (
    <div draggable className="draggable-item cursor-pointer">
      <div className={`item ${selected ? 'sel' : 'unsel'}`}>
        <div className="selTick" onClick={onSelect}></div>
        <div className="cmp">
          {content.innovationImages?.imageUrl ? (
            <div
              className="relative w-full overflow-hidden border border-gray-300 bg-gray-50"
              style={{ paddingBottom: '73.25%', paddingTop: '30px', height: 0 }}
            >
              <ResponsiveImage
                image={content.innovationImages}
                widths={{ md: 300, lg: 400 }}
                imgProps={{ className: 'absolute inset-0 !object-contain' }}
              />
            </div>
          ) : (
            <div
              className="relative w-full overflow-hidden border border-gray-300 bg-gray-50"
              style={{ paddingBottom: '73.25%', paddingTop: '30px', height: 0 }}
            >
              <div className="absolute top-4 right-4 bottom-4 left-4 flex items-center justify-center">
                <IconComponent className="h-24 w-24" />
              </div>
            </div>
          )}
          <div className="h-[120px] border border-t-0 border-gray-300 bg-white p-3">
            <h4 className="mb-1 text-sm font-bold">Tech Launches Database</h4>
            <div className="filename">
              <h4 className="line-clamp-3 text-xs">{content?.title}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TechLaunchDatabaseFileItem;
